<template>
  <div class="dass-tracking-order">
    <OrderTrackingHeader
      v-if="order"
      :productImage="order?.LINK_IMAGEM"
      :productTitle="order?.PRO_NOME"
      :orderDate="order?.DATA"
      :orderNumber="order?.PED_CODIGO"
      :statusPed="order?.STATUS_PED"
    />
    <dass-divider />
    <div class="dass-tracking-order-grid">
      <div class="dass-tracking-order-details">
        <StatusStepInfo 
          v-if="order"
          :statusPed="order?.STATUS_PED"
          :address="`${order?.CLI_ENDERECO} / ${order?.CLI_ENDNUM} - ${order?.CLI_CIDADE}`"
          :carrier="order?.TRA_NOME"
          :estimate="order?.DATA_PREVISTA"
          :deliveredAt="order?.DATA_ENTREGA"
          :urlCarrier="order?.URL_TRANSP" 
          :order="order"
        />
      </div>
      <div class="dass-tracking-order-timeline">
        <TimelineInfoDetailsOrder /> 
      </div>
    </div>
  </div>
</template>

<script>
import OrderTrackingHeader from '../components/organisms/trackingOrder/OrderTrackingHeader.vue'
import { mapGetters, mapActions } from 'vuex';
import StatusStepInfo from '@/components/organisms/trackingOrder/StatusStepInfo.vue';
import TimelineInfoDetailsOrder from '@/components/organisms/trackingOrder/TimelineInfoDetailsOrder.vue';
const finalRoute = '171'
export default {
  name: 'TrackingOrder',
  components: {
    OrderTrackingHeader,
    StatusStepInfo,
    TimelineInfoDetailsOrder
  }, 
  computed: {
    ...mapGetters('orders', {
      orders: 'getOrders',
      getOccurrences: 'getOccurrences',
    }),
    pedCodigo() {
      return this.$route.params.ped_codigo;
    }, 
    getOcurrencesOrder() {      
      return this.getOccurrences?.filter((item) => item?.FAT_SEQUENCIA == this.order?.FAT_SEQUENCIA) || []
    },
    order() {
      return this.orders.find((item) => item.PED_CODIGO == this.pedCodigo)
    } 
    
  },  
  methods: {
    ...mapActions('orders', ['loadOrders', 'loadOccurrences']),
    ...mapActions('toasts', ['showToast']),  
    async initialize() {
      if(!this.orders.length) {
        await this.loadOrders({ped_codigo: this.pedCodigo})
        .catch(err => {
          this.showToast({
            variant: 'warning',
            message: err?.message || err,
          })
        });
      }
      const occurrenceOfOrder = this.getOcurrencesOrder.find((item) => item.PED_CODIGO == this.order?.PED_CODIGO)
      if(!occurrenceOfOrder) await this.loadTimelineDetails();         
    }, 
    async loadTimelineDetails() {      
      if(!this.order || !this.order?.PED_EMPRESA || !this.order?.PED_FILIAL || !this.order?.FAT_SEQUENCIA) return
      await this.loadOccurrences({
         ped_empresa: this.order?.PED_EMPRESA,
         ped_filial: this.order?.PED_FILIAL,
         fat_sequencia: this.order?.FAT_SEQUENCIA        
      }).catch((err) => {
        this.showToast({
          variant: 'warning',
          message: err?.message || err
        })
      });     
    }
  },
  mounted() {
    this.initialize();
  }
}
</script>

<style lang="scss" scoped>
.dass-tracking-order {  
  width: 100%;
  padding: 1.5% 3%;
}
.dass-tracking-order-grid {
  display: grid;
  grid-template-columns: 65% 35%;
  gap: 15px;
}
.dass-tracking-order-details {
  width: 100%;
  background: white;
}
.dass-tracking-order-timeline {
  width: 100%;
  background: white;
}
@media (max-width: 1050px) {
  .dass-tracking-order-grid {
    grid-template-columns: 100%;
  }
}
</style>